import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import routes from "./routes";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import PublicRoute from "./components/PublicRoute/PublicRoute";
import { Provider } from "react-redux";
import Promo from './pages/Promo/promo';
import store from "./store";
import OrderHistory from "./pages/Order-history/Order-history";
// import HomePage from "./pages/Homepage/Homepage.js";
import MenuItems from "./pages/MenuItems/MenuItems";
import Account from "./pages/Account/Account";
import Outlets from "./pages/Outlets/Outlets";
import Payment from "./pages/Payment/Payment";
import TrackOrder from "./pages/Track-order/Track-order";
import NotFound from "./pages/NotFound/notFound";
import { setCurrentUser } from "./actions/authActions";
import JoinUs from "./pages/JoinUs/JoinUs";
import { Route } from "react-router";
import PaymentStatus from "./pages/payment-status.js";
import PrivacyPolicy from "./components/Signup/PrivacyPolicy";
import TermsAndConditions from "./components/Signup/TermsAndConditions";
import URLWatcher from "./components/URLWatcher/URLWatcher.js";

if (localStorage.headers) {
  store.dispatch(setCurrentUser(localStorage.headers));
}

const App = () => {
  const routesKeys = [];
  for (let route in routes) {
    routesKeys.push(route);
  }

  return (
    <Provider store={store}>
      <Router>
        <URLWatcher />
        <Switch>
          {/* <PublicRoute exact path="/" component={HomePage} />  */}
          <PublicRoute exact path="/" component={MenuItems} />
          <PublicRoute exact path="/Account" component={Account} />
          <PublicRoute exact path="/OrderHistory" component={OrderHistory} />
          <PublicRoute exact path="/outlets" component={Outlets} />
          <PublicRoute exact path="/payment/:id?" component={Payment} />
          <PublicRoute exact path="/payment-status/" component={PaymentStatus} />

          <Route
            exact
            path="/joinus"
            render={() => {
              return (
                <JoinUs />
              );
            }} />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route exact path="/terms-and-condition" component={TermsAndConditions} />

          <PublicRoute exact path="/account" component={Account} />
          <PublicRoute exact path="/promo" component={Promo} />

          <PublicRoute
            exact
            path="/order-history/:id?"
            component={OrderHistory}
          />
          <PublicRoute
            exact
            path="/track-order/:id?"
            component={TrackOrder}
          />

          {routesKeys.map((key) => {
            return (
              <PublicRoute
                path={`${routes[key].path}`}
                component={routes[key].component}
                key={key}
                exact={routes[key].exact}
                name={routes[key].name}
              />
            );
          })}
          <PublicRoute exact path="/Error" component={NotFound} />
        </Switch>
      </Router>
    </Provider>
  );
};

export default App;
